import { render, staticRenderFns } from "./CostCreateUpdate.vue?vue&type=template&id=021b36ef&"
import script from "./CostCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CostCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports